import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Livecoding recap #43: A landing page for React + D3v4",
  "description": "",
  "published": "2017-08-08T00:00:00.000Z",
  "redirect_from": ["/blog/livecoding-recap-43-landing-page-react-d3v4/swizec/7743"],
  "categories": "Livecoding, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`This is a Livecoding Recap – an almost-weekly post about interesting things discovered while livecoding. Usually shorter than 500 words. Often with pictures. Livecoding happens almost `}<strong parentName="em">{`every Sunday at 2pm PDT`}</strong>{` on multiple channels. You should follow `}<a parentName="em" {...{
          "href": "https://www.youtube.com/TheSwizec"
        }}>{`My Youtube`}</a>{` channel to catch me live.`}</em></p>
    <lite-youtube {...{
      "videoid": "D9XDRshisjQ",
      "videostartat": "0"
    }}></lite-youtube>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=hFo5g04e0Wc"
      }}>{`Part 2`}</a>{` and `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=b6yqf_v6w9A"
      }}>{`Part 3`}</a></p>
    <p>{`It's 3am, I'm tired, and I have no wisdom to share.`}</p>
    <p>{`On Sunday, I spent 5 hours livestreaming while I prepped for launch of the new React + D3v4 book. Publish a new version on Leanpub, set up a new product on Gumroad, decide Stripe is not the way to go, think about email sequences, and… build a landing page.`}</p>
    <p>{`That's where things got hard.`}</p>
    <p>{`Building landing pages is hard. It's not the building itself that's hard. I have a template for that. It’s a template that I've long since turned into a collection of React components, even.`}</p>
    <p>{`Filling those components, that's the hard part.`}</p>
    <p>{`How do you sell your product? Why would anyone buy what you made? Who are they? What's the problem they're solving? Are there many problems? What's the most common one? How do you explain all of this in a way that makes sense?`}</p>
    <p>{`How do you grab someone's attention? Are you speaking to your audience or shouting at the void?`}</p>
    <p><em parentName="p">{`That`}</em>{` stuff is hard. That stuff right there. Makes me wanna pull my hair out.`}</p>
    <p>{`Somewhere, deep down, I think I know the answers to all those questions. But what if I don't? What if I'm wrong.`}</p>
    <p>{`I showed `}<a parentName="p" {...{
        "href": "https://react-d3js-landing-page-mbnbcvgyit.now.sh/"
      }}>{`what I had so far`}</a>{` to a friend, and he said `}<em parentName="p">{`"Nah, you're making me think. Why are you pitching 3 different ways right at the top?"`}</em></p>
    <p>{`I DON’T KNOW WHY. Because 3 different people buy my book? Because I'm not saying 3 different things, but it isn't coming out well? 😭`}</p>
    <p>{`This shit's hard. I need to spend more time reading books on copywriting. Good copywriting reads almost like poetry, flows like a fairy tale, and makes you want to keep reading and reading. You're almost afraid the buy button will come too soon because you're enjoying the read so much.`}</p>
    <p>{`My copywriting… heh… my copywriting sounds like you put Hemingway and Godin in a blender and hoped for the best.`}</p>
    <p>{`But at least I'm using the `}<a parentName="p" {...{
        "href": "https://antonsten.com/understanding-pain-dream-fix/"
      }}>{`Pain Dream Fix`}</a>{` approach. There's hope, ya know.`}</p>
    <p>{`The idea behind Pain Dream Fix is that your customers have a pain that they're looking to solve. They have a dream of what they want to be like. It’s the superpower they want to have, if you will. And you can offer a fix to their pain that gets them to their dream.`}</p>
    <p>{`Sell customers a better version of themselves, not just some product properties. Nobody gives a shit about your product, they're in it for themselves. As they should be.`}</p>
    <p>{`If all goes well, launch is next week. I can keep improving the landing page for one forever at least.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      